<template>
  <div class="selfMenu">
    <div class="create-application" v-if="sidebarType == 1">首页</div>
    <div class="create-application" v-if="sidebarType == 2">智能AI服务</div>
    <h-menu
      theme="dark"
      :active-name.sync="activeName"
      :open-names="openArray"
      :collapse="isCollapse === 'true'"
      accordion
      :vertiSide="true"
      width="154px"
      @on-select="goSelected"
    >
      <Submenu name="1" v-show="sidebarType == 1">
        <template slot="title">
          <h-icon class="console-menu-icon service-icon"></h-icon>
          服务管理
        </template>
        <a href="/cloud/open/serviceapply/myApply.html">
          <h-menu-item name="1-1">我的申请</h-menu-item>
        </a>
        <a href="/console/services.html">
          <h-menu-item name="1-2">我的服务</h-menu-item>
        </a>
        <a href="/console/favorite.html">
          <h-menu-item name="1-3">我的收藏</h-menu-item>
        </a>
        <a href="/cloud/open/serviceapply/myApp.html">
          <h-menu-item name="1-3">我的应用</h-menu-item>
        </a>
        <a href="/openplat-front/console/myCertificate">
          <h-menu-item name="1-4">我的证书</h-menu-item>
        </a>
      </Submenu>
      <Submenu name="2" v-if="sidebarType == 1">
        <template slot="title">
          <h-icon class="console-menu-icon trade-icon"></h-icon>
          交易管理
        </template>
        <a href="/console/order.html">
          <h-menu-item name="2-1">我的订单</h-menu-item>
        </a>
        <a href="/console/account_management.html">
          <h-menu-item name="2-2">账户充值</h-menu-item>
        </a>
        <a href="/cloud/open/netSign/billList.html">
          <h-menu-item name="2-2">费用账单</h-menu-item>
        </a>
        <a href="/console/coupon_management.html">
          <h-menu-item name="2-2">我的优惠券</h-menu-item>
        </a>
        <a href="/console/contract_manage.html">
          <h-menu-item name="2-2">我的合同</h-menu-item>
        </a>
        <Submenu
          name="1-3"
          :showSlide="true"
          :vertiSide="true"
          @mouseenter.native="showChildren($event)"
        >
          <template slot="title"> 我的发票 </template>
          <a href="/console/invoicePage.html">
            <h-menu-item name="1-3-1">申请开票</h-menu-item>
          </a>
          <a href="/console/invoiceList.html">
            <h-menu-item name="1-3-2">发票管理</h-menu-item>
          </a>
          <a href="/console/invoiceInformation.html">
            <h-menu-item name="1-3-3">开票信息</h-menu-item>
          </a>
        </Submenu>
      </Submenu>
      <Submenu name="3" v-if="sidebarType == 1">
        <template slot="title">
          <h-icon class="console-menu-icon data-icon"></h-icon>
          数据分析
        </template>
        <a href="/console/data_analysis.html">
          <h-menu-item name="3-1">api调用数据</h-menu-item>
        </a>
        <a href="/console/StatsPay.html">
          <h-menu-item name="3-2">交易数据</h-menu-item>
        </a>
      </Submenu>
      <Submenu name="4" v-if="sidebarType == 1">
        <template slot="title">
          <h-icon class="console-menu-icon order-icon"></h-icon>
          工单管理
        </template>
        <a href="/openplat-provider/#/userConsole/bussinessWork/workOrder">
          <h-menu-item name="4-1">工单管理</h-menu-item>
        </a>
      </Submenu>
      <Submenu name="6" v-if="sidebarType == 1">
        <template slot="title">
          <h-icon class="console-menu-icon info-icon"></h-icon>
          账户信息
        </template>
        <a href="/console/accountInfo.html">
          <h-menu-item name="6-1">基本信息</h-menu-item>
        </a>
        <a href="/console/authentication.html">
          <h-menu-item name="6-2">实名认证</h-menu-item>
        </a>
        <a href="/console/securityCenter.html">
          <h-menu-item name="6-3">安全中心</h-menu-item>
        </a>
        <a href="/console/invite_manage.html">
          <h-menu-item name="6-4">邀请码管理</h-menu-item>
        </a>
        <a href="/console/invoiceLocation.html">
          <h-menu-item name="6-5">收货地址</h-menu-item>
        </a>
      </Submenu>
      <!-- <router-link to="/console/myMessage">
        <h-menu-item name="7" v-if="sidebarType == 1">
          <h-icon class="console-menu-icon message-icon"></h-icon>
          <span class="message-link">我的消息</span>
        </h-menu-item>
      </router-link> -->
      <a href="/openplat-front/console/myMessage">
        <h-menu-item name="7" v-show="sidebarType == 1">
          <h-icon class="console-menu-icon message-icon"></h-icon>
          <span class="message-link">我的消息</span>
        </h-menu-item>
      </a>
    </h-menu>
  </div>
</template>
<script>
export default {
  name: "SidebarItem",
  data() {
    return {
      isCollapse: "false",
      activeName: "",
      openArray: [],
      sidebarType: ""
    };
  },
  watch: {
    $route(to, from) {
      console.log(to);
      //
      this.sidebarType = this.$route.meta.invoice == true ? 1 : 2;
    }
  },
  props: {
    routes: {
      type: Array
    }
  },
  mounted() {
    this.sidebarType = this.$route.meta.invoice == true ? 1 : 2;
    let active = this.$route.meta.activeName;
    this.activeName = active ? active : "";
    this.openArray = [this.$route.meta.activeName.split("-")[0]];
  },
  methods: {
    goSelected(val) {
      this.activeName = val;
      this.openArray = [val.split("-")[0]];
    },
    showChildren(el) {
      let top = el.currentTarget.getBoundingClientRect().top,
        left = el.currentTarget.getBoundingClientRect().left,
        childNode = el.currentTarget.children[1];
      childNode.style.top = top + "px";
      childNode.style.left = "153px";
      childNode.style.width = "153px";
      //childNode.style.display = 'block'
      childNode.style.position = "fixed";
    }
  }
};
</script>
<style lang="scss">
.selfMenu {
  position: fixed;
  top: 60px;
  left: 0;
  height: 100%;
  bottom: 0;
  left: 0;
  background: #051337;
  overflow-y: auto;
  .create-application {
    width: 153px;
    height: 50px;
    background: rgba(75, 131, 255, 1);
    font-size: 18px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 50px;
    text-align: center;
  }
  .h-menu {
    //width: 154px !important;
    .console-menu-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 30px;
      width: 14px;
      height: 14px;
      margin-top: -2px;
      background-size: contain;
    }
    .service-icon {
      background: url("~@/assets/console/fwgl.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
    }
    .trade-icon {
      background: url("~@/assets/console/jygl.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
    }
    .data-icon {
      background: url("~@/assets/console/sjfx.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
    }
    .order-icon {
      background: url("~@/assets/console/gdgl.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
    }
    .info-icon {
      background: url("~@/assets/console/zhgl.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
    }
    .message-icon {
      background: url("~@/assets/console/message.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
    }
    .my-message {
      background: url("~@/assets/console/message.png") center center no-repeat;
      cursor: pointer;
      background-size: contain;
      // .icon-unfold:before {
      //   content: "";
      // }
      // .h-menu-item-active.h-menu-item-selected:hover {
      //   background: #2765d8 !important;
      // }
    }
    .message-link {
      color: #a5aab7;
      font-weight: 700;
    }
    .selected {
      background: #2765d8 !important;
      color: #ffffff;
    }
  }
  // .icon-stats-bars:before {
  //   margin-left: -15px;
  // }
  // .icon-qrcode_fill:before {
  //   margin-left: -15px;
  // }
  .h-menu .iconfont {
    margin-left: -15px;
  }
  .icon-headlines:before {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 14px;
  }
  .h-menu-vertical .h-menu-submenu-title-icon {
    top: 14px;
  }
  .h-menu-opened > .h-menu-submenu-title > .h-menu-submenu-title-icon {
    top: 12px;
  }
}
.selfMenu .h-sidebar-menu .h-menu-dark.h-menu-vertical .h-menu-item,
.h-sidebar-wrapper
  .selfMenu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu-title {
  padding: 14px 24px 14px 45px;
  color: #a5aab7;
}
.h-sidebar-wrapper .h-sidebar-menu .h-menu-dark.h-menu-vertical .h-menu-item,
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu
  .h-menu-submenu
  .h-menu-submenu-title {
  padding: 9px 20px 9px 44px;
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu
  .h-menu-item:hover,
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu-title:hover {
  background: #051337 !important;
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-opened
  .h-menu-submenu
  .h-menu-submenu-title:hover {
  background: #051337 !important;
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu
  .h-menu-item-active.h-menu-item-selected,
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu
  .h-menu-item-active.h-menu-item-selected:hover {
  background: #2765d8 !important;
  border-radius: 0px !important;
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu
  .h-menu-item:hover {
  background: #051337 !important;
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu-title:hover {
  color: #ffffff !important;
  .service-icon {
    background: url("~@/assets/console/fwglHover.png") center center no-repeat;
    cursor: pointer;
    background-size: contain;
  }
  .trade-icon {
    background: url("~@/assets/console/jyglHover.png") center center no-repeat;
    cursor: pointer;
    background-size: contain;
  }
  .data-icon {
    background: url("~@/assets/console/sjfxHover.png") center center no-repeat;
    cursor: pointer;
    background-size: contain;
  }
  .order-icon {
    background: url("~@/assets/console/gdglHover.png") center center no-repeat;
    cursor: pointer;
    background-size: contain;
  }
  .info-icon {
    background: url("~@/assets/console/zhglHover.png") center center no-repeat;
    cursor: pointer;
    background-size: contain;
  }
  a {
    color: #ffffff !important;
  }
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu-title
  > i:hover {
  color: #ffffff !important;
}
.h-sidebar-menu {
  padding: 0px 10px 0 0;
}
.h-sidebar-wrapper .h-sidebar-menu .h-menu-dark.h-menu-vertical .h-menu-item {
  color: #a5aab7;
}
.h-sidebar-wrapper
  .h-sidebar-menu
  .h-menu-dark.h-menu-vertical
  .h-menu-submenu
  .h-menu-submenu
  > .h-menu {
  background: #1c232f;
}
.h-sidebar-wrapper .h-sidebar-menu .h-menu-dark.h-menu-vertical .h-menu-item {
  &.h-menu-item-active.h-menu-item-selected,
  &:hover {
    color: #ffffff;
    background: #051337;
    border: none;
    span {
      color: #ffffff;
    }
    .message-icon {
      background: url("~@/assets/console/messageHover.png") center center
        no-repeat;
      cursor: pointer;
      background-size: contain;
    }
  }
  &.h-menu-item-active.h-menu-item-selected,
  &:focus {
    background: #00aaee;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/consoleViews/bizFrame/SidebarItem.vue